import { gradeMeta } from '../lib/grades';

interface Props {
  code: string | null | undefined;
  size?: 'sm' | 'md' | 'lg';
}

export function GradeBadge({ code, size = 'md' }: Props) {
  const meta = gradeMeta(code);
  const sizing =
    size === 'lg'
      ? 'px-4 py-1 text-lg font-bold'
      : size === 'sm'
        ? 'px-2 py-0.5 text-xs font-semibold'
        : 'px-3 py-1 text-sm font-semibold';
  return (
    <span
      title={meta.label}
      className={`inline-block border-2 rounded ${sizing} ${meta.classes}`}
    >
      {meta.code}
    </span>
  );
}
